<style scoped>
.excel-span {
  height: 24px;
  line-height: 24px;
  display: inline-block;
  padding: 1px 8px 1px 8px;
  border-radius: 4px;
  background-color: #f4f4f5;
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
</style>
<template>
  <div>
    <el-dialog :visible.sync="visible" :title="title" append-to-body="append-to-body">
      <div :loading="loading" :class="[tableData.length>0?'dialog-scroller':'']"
          style="display: flex;flex-direction: column;">
        <!--上传-->
        <div>
          <input id="matterFileInput" ref="excel-upload-input" class="excel-upload-input" type="file" multiple
              accept=".xlsx, .xls" @change="handleClick">
          <el-button :loading="loading" size="mini" type="primary" icon="el-icon-document-add"
              @click="exportModel">
            {{$t('xiazaimuban')}}
          </el-button>
          <el-button :loading="loading" size="mini" type="default" icon="el-icon-plus" @click="handleUpload">
            {{$t('piliangshangchuan')}}
          </el-button>
        </div>
        <!--excel-->
        <div style="margin-top: 10px">
					<span v-for="(item, index) in excel" :key="index" class="excel-span" closable size="mini">
						<i class="el-icon-link"/>
						<span>{{item}}</span>
						<i style="margin-left: 5px" class="el-icon-close" @click="deleteExcel(item)"/>
					</span>
        </div>
        <!--表格-->
        <div ref="table" style="flex: 1;margin-top: 10px;">
<!--          :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize,pagination.currentPage * pagination.pageSize)"-->
          <el-table stripe :max-height="tableHeight" :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize,
                pagination.currentPage * pagination.pageSize
              )"
                    border size="mini"
                    :header-cell-style="{background: '#F5F7FA',  color:'#606266','font-weight':'700', height:'48px', padding:'0px'}">
            <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop"
                :show-overflow-tooltip="true" :label="item.label" :width="item.width"
                :sortable="item.sortable">
              <template slot-scope="scope">
								<span>{{
                    scope.row[item.prop] === "" ? "-" : scope.row[item.prop]
                  }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
          <el-pagination v-if="tableData.length>0" style="display: flex;float: right;"
                         background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :pagerCount="5"
                         :page-size="pagination.pageSize" layout="total,sizes,prev,pager,next"
                         :total="tableData.length" @size-change="handleSizeChange"
                         @current-change="handleCurrentChange" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button type="default" size="mini" @click="visible = false">{{$t('quxiao')}}</el-button>
				<el-button type="primary" size="mini" @click="importData">{{$t('baocun')}}</el-button>
			</span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      listLength: '',
      excel: [],
      tableHeight: 0,
      tableData: [],
      tableColumn: [
        {
          label: this.$t('daorubaogao'),
          prop: 'result',
          width: 125
        }, {
          label: this.$t('shebeiSN'),
          prop: 'sn',
          width: 125
        },
        {
          label: this.$t('shebeixinghao'),
          prop: 'modelCode',
          width: 110
        },
        {
          label: this.$t('kehubianma'),
          prop: 'customerCode',
        },
        {
          label: this.$t('shujumoban'),
          prop: 'template',
          width: 145
        },
        {
          label: this.$t('jingtaitu'),
          prop: 'imgSrcStatic',
          width: 145
        },
        {
          label: this.$t('dongtaitu'),
          prop: 'imgSrcDynamic',
          width: 145
        },
        {
          label: this.$t('chuchangriqi'),
          prop: 'leaveFactoryDate',
          width: 160
        },
        {
          label: this.$t('guishuSN'),
          prop: 'belongSn',
          width: 145
        },
        {
          label: this.$t('shebeimingcheng'),
          prop: 'name',
          width: 145
        },
        {
          label: this.$t('dunwei'),
          prop: 'tonnage',

        },
        {
          label: this.$t('paixu'),
          prop: 'sort',
          with: 60
        },
        {
          label: this.$t('jingdu'),
          prop: 'longitude',
          with: 120
        },{
          label: this.$t('weidu1'),
          prop: 'latitude',
          with: 120
        },{
          label: this.$t('shifoujinxingBase64jiema'),
          prop: 'eventTranslatedCancel',
          with: 160
        },{
          label: this.$t('shebeizhizaoshang'),
          prop: 'manufacturer',
          with: 120
        }
      ],
      // pagination: {
      //   currentPage: 1,
      //   pageSize: 10
      // },
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      visible: false,
      title: this.$t('daoru')
    }
  },
  watch: {
    show: {
      handler(n) {
        this.visible = n
        if (n == true) {
          this.countTableHeight()
        }
        if (n == false) {
          this.currentPage = 1
        }
      },
      immediate: false
    },
    visible: {
      handler(n) {
        if (!n) {
          this.$emit('update:show', false)
          this.tableData = []
          this.excel = []
          this.$refs['excel-upload-input'].value = null
        }
      },
      immediate: false
    }
  },
  mounted() {

  },
  methods: {
    countTableHeight() {
      this.tableHeight = 0
      this.$nextTick(() => {
        if (this.tableData.length > 0) {
          this.tableHeight = this.$refs.table.offsetHeight - 10
        } else {
          this.tableHeight = 110
        }
      })
    },
    judgeType(obj) {
      // tostring会返回对应不同的标签的构造函数
      const toString = Object.prototype.toString;
      const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object',
      };
      if (obj instanceof Element) {
        return 'element';
      }
      return map[toString.call(obj)];
    },
    exportModel() {
      window.open(
          (process.env.NODE_ENV === "development" ? global.URL_DEV_API_BASE_DOMAIN :
              (process.env.VUE_APP_SERVER === 'preview' ? global.URL_PRE_API_BASE_DOMAIN : global.URL_PROD_API_BASE_DOMAIN)) +
          "/web/customer/files/viewFileByFileId/shebeixinxidaorumuban"
      );
    },
    importData() {
      const data = [...this.tableData]
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'))
        return;
      }
      for (let i = 0; i < data.length; i++) {
        //new Date(data[i]['leaveFactoryDate']).getTime()
        data[i]['leaveFactoryDate']?(new Date(data[i]['leaveFactoryDate']).getTime()):''
        data[i]['name'] ? (data[i]['name'] = (data[i]['name']) + '') : (data[i]['name'] = '')
        data[i]['belongSn'] ? (data[i]['belongSn'] = (data[i]['belongSn']) + '') : (data[i]['belongSn'] = '')
        data[i]['imgSrcStatic'] ? ((data[i]['imgSrcStatic']) + '') : (data[i]['imgSrcStatic'] = '')
        data[i]['customerCode'] ? ((data[i]['customerCode']) + '') : (data[i]['customerCode'] = '')
        data[i]['sn'] ? (data[i]['sn']) : (data[i]['sn'] = '')
        data[i]['template'] ? (data[i]['template']) : (data[i]['template'] = '')
        data[i]['tonnage'] ? (data[i]['tonnage']) : (data[i]['tonnage'] = '')
        data[i]['manufacturer'] ? (data[i]['manufacturer']) : (data[i]['manufacturer'] = '')
        delete data[i]['excel']
      }
      if (this.listLength==null  || this.listLength.length == 0) {
        return this.http.post('/web/equipment/batchCreate?onlyValidate=false', data).then(response => {
          this.utils.successMessage(this.$t(response.msg));
          this.show = false;
          // 刷新主页面列表(参数要与被调用得页面$on()中名称对应)
          this.utils.event_hub.$emit('ADMIN_INFO_REFRESH');
        })
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }

    },
    /**
     * 数据解析
     * @param header
     * @param results
     * @param name
     */
    generateData({
                   header,
                   results,
                   name
                 }) {
      const data = []
      if (results.length > 0) {
        for (let i = 0; i < results.length; i++) {
          const item = {
            excel: name
          }
          for (let j = 0; j < this.tableColumn.length; j++) {
            if (results[i][this.tableColumn[j]['label']]) {
              this.$set(
                  item,
                  this.tableColumn[j]['prop'],
                  results[i][this.tableColumn[j]['label']]
              )
            }
          }
          if (item['sn']) {
            data.push(item)
          }
        }
      }
      this.tableData = this.tableData.concat(data)
      for (let i = 0; i < this.tableData.length; i++) {
        this.$set(this.tableData[i], 'rid', i + 1)
      }
      this.excel.push(name)
      this.countTableHeight()
    },
    /**
     * 显示上传弹框
     */
    handleUpload() {
      this.$refs['excel-upload-input'].click()
    },
    /**
     * 点击上传
     * @param e
     * @returns {Promise<void>}
     */
    async handleClick(e) {
      const files = e.target.files
      for (let i = 0; i < files.length; i++) {
        this.beforeUpload(files[i])
      }
      document.getElementById('matterFileInput').value = ''
      setTimeout(() => {
        let data = [...this.tableData]
        for (let i = 0; i < data.length; i++) {
          data[i]['leaveFactoryDate']?(new Date(data[i]['leaveFactoryDate']).getTime()):''
          data[i]['name'] ? (data[i]['name'] = (data[i]['name']) + '') : (data[i]['name'] = '')
          data[i]['belongSn'] ? (data[i]['belongSn'] = (data[i]['belongSn']) + '') : (data[i]['belongSn'] = '')
          data[i]['imgSrcStatic'] ? ((data[i]['imgSrcStatic']) + '') : (data[i]['imgSrcStatic'] = '')
          data[i]['customerCode'] ? ((data[i]['customerCode']) + '') : (data[i]['customerCode'] = '')
          data[i]['sn'] ? (data[i]['sn']) : (data[i]['sn'] = '')
          data[i]['template'] ? (data[i]['template']) : (data[i]['template'] = '')
          data[i]['tonnage'] ? (data[i]['tonnage']) : (data[i]['tonnage'] = '')
          data[i]['manufacturer'] ? (data[i]['manufacturer']) : (data[i]['manufacturer'] = '')
          delete data[i]['excel']
        }
        this.http.post('/web/equipment/batchCreate?onlyValidate=true', data).then(response => {
          console.log('response', response.data)
          this.listLength = response.data.validateItems
          if (response.data.validateItems && response.data.validateItems.length > 0) {
            const list = response.data.validateItems
            for (let i = 0; i < list.length; i++) {
              this.$set(this.tableData[Number(list[i]['index'])], 'result', list[i]['items'].join(','))
            }
          }
        }).catch(response => {
          // console.log('response',response)
        })
      }, 800)
    },
    /**
     * 上传前
     * @param rawFile
     * @returns {boolean}
     */
    beforeUpload(rawFile) {
      if (this.excel.length < 2) {
        //this.$refs['excel-upload-input'].value = null
      }
      if (!this.isExcel(rawFile)) {
        this.$message.error(this.$t('zhizhichi') + '.xlxs,xls,csv' + this.$t('geshiwenjian'));
        return false
      }
      if (this.excel.length > 2) {
        this.$message.error(this.$t('zuidazhichi') + '3' + this.$t('geexcelwenjian'));
        return false
      }
      if (this.excel.includes(rawFile.name)) {
        this.$message.error(rawFile.name + this.$t('wenjianyicunzai'));
        return false
      }
      this.readerData(rawFile)
    },

    /**
     * 解析excel
     * @param rawFile
     */
    readerData(rawFile) {
      this.loading = true
      const reader = new FileReader()
      reader.onload = (e) => {
        const name = rawFile.name
        const data = e.target.result
        const workbook = XLSX.read(data, {
          type: 'array'
        })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const header = this.getHeaderRow(worksheet)
        const results = XLSX.utils.sheet_to_json(worksheet)
        this.generateData({
          header,
          results,
          name
        })
        this.loading = false
      }
      reader.readAsArrayBuffer(rawFile)
    },
    /**
     * 获取excel头部
     * @param sheet
     * @returns {[]}
     */
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell = sheet[XLSX.utils.encode_cell({
          c: C,
          r: R
        })]
        let hdr = 'UNKNOWN ' + C
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    /**
     * 判断是否为excel文件
     * @param file
     * @returns {boolean}
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },


    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
    },

    /**
     * 刪除excel
     * @param name
     */
    deleteExcel(name) {
      this.excel = this.excel.filter((item) => {
        return item !== name
      })
      this.tableData = this.tableData.filter((item) => {
        return item.excel !== name
      })
      console.log("excel:", this.excel)
      console.log('tableData:', this.tableData)
      console.log('tableColumn', this.tableColumn)
    }
  }
}
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
